var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"navLocalComp"}},[_c('div',[_c('button',{staticClass:"nav_item",on:{"click":_vm.toAll}},[_vm._v(_vm._s(_vm.all))]),_c('img',{attrs:{"src":require("../assets/icon-next.png")}}),(_vm.id)?_c('span',{staticClass:"nav_item active",attrs:{"disabled":""}},[_vm._v(_vm._s(_vm.id))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }